import PopupMenu from './PopupMenu';

export default {
  __init__: [ 'popupMenu' ],
  popupMenu: [ 'type', PopupMenu ]
};
